module.exports = __webpack_public_path__ + "img/473.7412d555.png";